import React, {useState} from "react";
import {IconButton} from "@mui/material";
import {IconSettings} from "@tabler/icons-react";
import {CreateFlowModal} from "../CreateFlow";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";
import {RAIL} from "../rail/railTokens";

export const FlowBlock = ({project, onUpdateProject, getUserProjects, flow, onSelectFlow}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedFlow, setSelectedFlow] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateFlow = async (newProject) => {
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.flows?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    );

    return (
        <>
            <CreateFlowModal
                project={project}
                open={openModal}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedFlow(null);
                }}
                flow={selectedFlow}
                handleSubmit={onUpdateFlow}
            />
            <ListBlock
                isOpen
                title="Flows"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(item) => (
                    <SideItemRow
                        key={item?.id || item?.key}
                        label={item?.name}
                        tooltip={item?.name}
                        active={item?.id === flow?.id}
                        onClick={() => onSelectFlow(item)}
                        action={
                            <IconButton
                                size="small"
                                sx={{p: 0.25, color: RAIL.muted, "&:hover": {color: RAIL.accent}}}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setSelectedFlow(item);
                                    setOpenModal(true);
                                }}
                            >
                                <IconSettings size={14}/>
                            </IconButton>
                        }
                    />
                )}
            />
        </>
    );
};
